import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'HostRequests';

const HostRequestsApi: any = baseApi(endpoint);

export default HostRequestsApi;